module.exports = __webpack_public_path__ + "static/media/Erneuerbare Energien.ad79785d.jpg";